export const FIRST_NODE_X = 100;
export const DISTANCE_BETWEEN_NODES = 350;
export const TIMELINE_Y = 400;
export const NODE_WIDTH = 300;
export const DISTANCE_FROM_TIMELINE = 80;
export const NODE_HEIGHT = 200;

export const defaultHeaders = (accessToken: string) => ({
  mode: 'cors' as RequestMode,
  cache: 'no-cache' as RequestCache,
  credentials: 'same-origin' as RequestCredentials,
  headers: new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  }),
});
